import { InjectionToken } from '@angular/core';
import { AiCallType } from './models/ai-call-type.enum';

/**
 * Context for AI feedback component.
 * Provide this at component level when using p-ai-feedback or p-ai-floating-dialog.
 */
export interface PAiFeedbackContext {
    automationPrefix: string;
    projectId: number;
    requestId: string;
    entityId: number;
    aiCallType: AiCallType;
}

export const P_AI_FEEDBACK_CONTEXT = new InjectionToken<PAiFeedbackContext>(
    'Context for AI feedback component'
);
